// This hook loads all active Vancouver distribution and approved community locations
import { useEffect, useState } from "react";
import useFirestore from "./useFirestore";

export default function useActiveLocations() {
  const database = useFirestore();
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [locations, setLocations] = useState([]);

  async function fetchLocations() {
    setLoading(true);
    setError(null);

    try {
      const dataTransfer = [];
      // 1️⃣ Load Vancouver Distribution Locations
      const pickupLocationDocRef = database
        .collection("DistributionLocations")
        .doc("Vancouver");
      // Pull the pickupLocations
      const pickupDoc = await pickupLocationDocRef.get();
      const pickupData = pickupDoc.data();
      // Checks if the pickup exists.
      if (pickupData) {
        // Add the locations that are still active.
        Object.entries(pickupData).forEach(([location, details]) => {
          if (details.status !== "inactive") {
            dataTransfer.push(location);
          }
        });
      }

      // 2️⃣ Load Approved Community Locations
      const communitySnapshot = await database
        .collection("CommunityLocations")
        .where("approved", "==", true)
        .get();

      communitySnapshot.forEach((doc) => {
        const data = doc.data();
        if (data.locationName) {
          dataTransfer.push(data.locationName);
        }
      });

      // ✅ Update state once
      setLocations(dataTransfer);
    } catch (err) {
      console.error("Error fetching locations:", err);
      setError(err);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchLocations();
  }, [database]);

  return { locations, loading, error };
}
